module.exports = __webpack_public_path__ + "img/4-2.52116941.png";